import { AuthPage } from './AuthPage';

export function LoginPage() {
  return <AuthPage mode="login" />;
}
